const Footer = () => {
  return (
    <div className="section bg-dark">
      <div className="container">
        <div className="footer-info-box text-center">
          <h4 className="title">Let’s work together</h4>
          <h2 className="mail">
            <a href="mailto:harmeet.sandal@gmail.com">
              harmeet.sandal@gmail.com
            </a>
          </h2>
        </div>

        <div className="footer-copyright-social">
          <div className="footer-copyright">
            <p>
              Copyright &copy; {new Date().getFullYear()} Code with Harmeet -
              All Rights Reserved.
              {/* <a
                href="https://hasthemes.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                HasThemes
              </a> */}
            </p>
          </div>
          <div className="footer-social">
            <ul className="social">
              <li>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className="behance"
                  href="https://www.linkedin.com/in/-harmeet-singh/"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className="github"
                  href="https://github.com/harmeetsingh17"
                >
                  Github
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
